"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
/**
 * 卡券类型样式
 */
function Snap(props) {
    var isMobile = props.isMobile, theme = props.theme;
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    var themeClass = "snap-theme-".concat(theme || 'blue');
    function renderSnapVer() {
        return (react_1.default.createElement("div", { className: "coupon-snap-ver" },
            react_1.default.createElement("div", { className: "snap-left" }),
            react_1.default.createElement("div", { className: "snap-right" }),
            react_1.default.createElement("div", { className: "snap-circle" }),
            react_1.default.createElement("div", { className: "snap-line" })));
    }
    function renderSnapHor() {
        return (react_1.default.createElement("div", { className: "coupon-snap-hor" },
            react_1.default.createElement("div", { className: "snap-top" }),
            react_1.default.createElement("div", { className: "snap-buttom" }),
            react_1.default.createElement("div", { className: "snap-circle" }),
            react_1.default.createElement("div", { className: "snap-line" })));
    }
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(classPrefix, "-coupon-snap"), themeClass) }, isMobile ? renderSnapHor() : renderSnapVer()));
}
exports.default = Snap;
//# sourceMappingURL=Snap.js.map